import {fieldEnhancements} from './field_enhancements';
import {Basics} from './basics';
import {searchFormHelpers} from './search_form_helpers';
import {MapPositionStorage} from './../search_results/map_position_storage';

function init() {

  MapPositionStorage.deleteByPrefix('AdvancedAddressSearch');

  Basics.previous_mls_ids = Basics.mls_id().val();

  $('#content').show();
  hidePageLoadingMsg();

  // Relative Date support
  $(document).on('click', '.exchange_icon', function() {
    searchFormHelpers.toggleDateRelativity($(this));
    searchFormHelpers.findCount();
  });

  setupForm();
  Basics.bind_selects();

  window.addEventListener('searchForm:filterChanged', function(e) {
    searchFormHelpers.updateViewResultsHref(e.detail);
  });

  window.addEventListener('searchForm:fieldsReloaded', function(e) {
    setupForm();
  });
}

function setupForm(){

  fieldEnhancements.multiSelectDropdowns();
  fieldEnhancements.searchableFieldLists();

  $("#added-fields :input").change(searchFormHelpers.findCount);

  Basics.update_status_date_fields();
}

export var advancedAddressSearch = {
  init: init,
};
